// frame: Isk7n @ ui/dogdisk-user.pen 弹框-测试节点(CDN)
// 触发:`zkY66/kENKt/qCOtS nodeBtn` / `EKOSx Q0ZoB` / `QQKOK 4UxoA`(切换节点 row)
//
// MVP:不实际测速,仅显示静态节点列表 + 当前选中标识 + "应用最快" 按钮(client-side ping all)
// 后端联调:GET /gapi/cdn/nodes 后端推 + POST /me.cdn_node 持久化(P3 backlog)

export type CdnNode = {
  id: string
  name: string
  region: string
  /** 资源域名主域(真人测速归因用;'auto' 等虚拟节点无 domain) */
  domain?: string
  /** ms,空表示未测 */
  latency?: number | null
}

export type NodeTestModalProps = {
  open: boolean
  onClose: () => void
  nodes: CdnNode[]
  currentNodeId: string | null
  onApply: (nodeId: string) => void
  /** 触发 client-side ping 全节点 */
  onPingAll?: () => void
  pinging?: boolean
}

export function NodeTestModal({
  open,
  onClose,
  nodes,
  currentNodeId,
  onApply,
  onPingAll,
  pinging = false,
}: NodeTestModalProps) {
  if (!open) return null

  const fastest = nodes
    .filter((n) => typeof n.latency === 'number')
    .sort((a, b) => (a.latency ?? Infinity) - (b.latency ?? Infinity))[0]

  return (
    <div
      data-frame-id="Isk7n"
      data-testid="Isk7n"
      role="dialog"
      aria-modal="true"
      aria-label="切换节点"
      className="fixed inset-0 z-50 flex items-end bg-black/50"
      onClick={onClose}
    >
      <div
        className="mx-auto w-full max-w-[402px] rounded-t-3xl bg-white"
        style={{ paddingBottom: 'max(34px, env(safe-area-inset-bottom))' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-center pt-2 pb-3">
          <span className="h-1 w-10 rounded-full bg-[#E0E0E0]" />
        </div>
        <header className="px-6 py-2 flex items-center justify-between">
          <h2 className="text-[15px] font-semibold text-[#1A1A1A]">选择节点</h2>
          {onPingAll && (
            <button
              type="button"
              data-testid="Isk7n-ping-all"
              onClick={onPingAll}
              disabled={pinging}
              className="text-[12px] text-[#19caad] disabled:opacity-50"
            >
              {pinging ? '测速中…' : '测速'}
            </button>
          )}
        </header>
        <ul className="max-h-[60vh] overflow-y-auto px-2">
          {nodes.length === 0 ? (
            <li className="px-4 py-6 text-center text-[13px] text-[#9CA3AF]">暂无节点</li>
          ) : (
            nodes.map((n) => {
              const active = n.id === currentNodeId
              return (
                <li key={n.id}>
                  <button
                    type="button"
                    data-testid={`Isk7n-node-${n.id}`}
                    onClick={() => {
                      onApply(n.id)
                      onClose()
                    }}
                    className={
                      'flex h-12 w-full items-center justify-between rounded-lg px-4 text-left text-[14px] active:bg-[#F6F7F8] ' +
                      (active ? 'text-[#19caad] font-semibold' : 'text-[#1A1A1A]')
                    }
                  >
                    <span>
                      {n.name}
                      <span className="ml-1 text-[11px] text-[#9CA3AF]">{n.region}</span>
                    </span>
                    <span className="text-[12px] tabular-nums text-[#9CA3AF]">
                      {typeof n.latency === 'number' ? `${n.latency} ms` : '—'}
                      {active && <span className="ml-2 text-[#19caad]">✓</span>}
                    </span>
                  </button>
                </li>
              )
            })
          )}
        </ul>
        <div className="flex gap-2 px-6 pt-3 pb-3">
          <button
            type="button"
            data-testid="Isk7n-cancel"
            onClick={onClose}
            className="h-11 flex-1 rounded-lg bg-[#F1F2F4] text-[14px] font-semibold text-[#1A1A1A]"
          >
            取消
          </button>
          <button
            type="button"
            data-testid="Isk7n-apply-fastest"
            onClick={() => {
              if (fastest) {
                onApply(fastest.id)
                onClose()
              }
            }}
            disabled={!fastest}
            className="h-11 flex-1 rounded-lg bg-[#19caad] text-[14px] font-semibold text-white active:bg-[#14a18b] disabled:opacity-50"
          >
            应用最快
          </button>
        </div>
      </div>
    </div>
  )
}
